import { render } from "./DashboardCard.vue?vue&type=template&id=46d3cbd8&ts=true"
import script from "./DashboardCard.vue?vue&type=script&lang=ts"
export * from "./DashboardCard.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__